import React, { type ReactNode } from "react";
import * as RadixVisuallyHidden from "@radix-ui/react-visually-hidden";

export type VisuallyHiddenProps = React.ComponentPropsWithoutRef<
  typeof RadixVisuallyHidden.Root
> & {
  /**
   * Change the default rendered element for the one passed as a child, merging their props and behavior.
   * */
  asChild?: boolean;
  children: ReactNode;
  ["data-testid"]?: string;
};

export const VisuallyHidden = ({ asChild, children, ...props }: VisuallyHiddenProps) => (
  <RadixVisuallyHidden.Root asChild={asChild} {...props}>
    {children}
  </RadixVisuallyHidden.Root>
);
